// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ListVariantSwitcher_wrapper__9nftK","hideOnMobile":"ListVariantSwitcher_hideOnMobile__FJIAG","hideOnDesktop":"ListVariantSwitcher_hideOnDesktop__Fe7R4"};